import { NavigationItem } from '@trustedshops/tswp-core-ui';

export function getNavigationItemIdentity(item: NavigationItem): string {
  const unsafeItem = item as any;
  return [
    unsafeItem?.$id,
    unsafeItem?.id,
    unsafeItem?.key,
    unsafeItem?.uri,
    unsafeItem?.path,
    item?.order
  ]
    .filter(x => x !== undefined && x !== null && x !== '')
    .join('::');
}
